export class CampaignHeaderQueryParameters {
  description?: string;
  fordClaimTypesId?: string;
  fordConditionCodesId?: string;
  fordCustomerConcernCodesId?: string;
  id?: string;
  manufacturerId?: string;
  name?: string;
  operationCode?: string;
  page?: number;
  pageSize?: number;
  technicianGroupId?: string;
  technicianGroupName?: string;
  technicianId?: string;
  typeId?: string;

  constructor(obj?: CampaignHeaderQueryParameters) {
    if (obj) Object.assign(this, obj);
  }
}
